/*
|--------------------------------------------------------------------------
| FORMAT CURRENCY
|--------------------------------------------------------------------------
*/

export const formatCurrency = (
  amount,
  currency = "INR"
) => {
  const numericAmount =
    Number(amount) || 0;

  try {
    return new Intl.NumberFormat(
      "en-IN",
      {
        style: "currency",
        currency,
        maximumFractionDigits: 2,
      }
    ).format(numericAmount);
  } catch {
    return `${currency} ${numericAmount.toFixed(
      2
    )}`;
  }
};


/*
|--------------------------------------------------------------------------
| FORMAT DATE
|--------------------------------------------------------------------------
*/

export const formatDate = (
  value
) => {
  if (!value) {
    return "-";
  }

  const date =
    new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleDateString(
    "en-IN",
    {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }
  );
};


/*
|--------------------------------------------------------------------------
| FORMAT DATE TIME
|--------------------------------------------------------------------------
*/

export const formatDateTime = (
  value
) => {
  if (!value) {
    return "-";
  }

  const date =
    new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString(
    "en-IN",
    {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }
  );
};


/*
|--------------------------------------------------------------------------
| CHECK EXPIRATION
|--------------------------------------------------------------------------
*/

export const isExpired = (
  expiresAt
) => {
  if (!expiresAt) {
    return false;
  }

  return (
    new Date(expiresAt).getTime() <
    Date.now()
  );
};


/*
|--------------------------------------------------------------------------
| GET STATUS LABEL
|--------------------------------------------------------------------------
*/

export const getStatusLabel = (
  status
) => {
  switch (status) {
    case "ACTIVE":
      return "Active";

    case "ACCEPTED":
      return "Accepted";

    case "EXPIRED":
      return "Expired";

    case "REVOKED":
      return "Revoked";

    default:
      return status || "Unknown";
  }
};


/*
|--------------------------------------------------------------------------
| GET STATUS CLASS
|--------------------------------------------------------------------------
*/

export const getStatusClass = (
  status
) => {
  switch (status) {
    case "ACTIVE":
      return "status-active";

    case "ACCEPTED":
      return "status-accepted";

    case "EXPIRED":
      return "status-expired";

    case "REVOKED":
      return "status-revoked";

    default:
      return "status-default";
  }
};


/*
|--------------------------------------------------------------------------
| EXTRACT API ERROR
|--------------------------------------------------------------------------
*/

export const getApiErrorMessage = (
  error,
  fallback = "Something went wrong."
) => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  );
};


/*
|--------------------------------------------------------------------------
| VALIDATE TOKEN
|--------------------------------------------------------------------------
*/

export const isValidPublicOfferToken = (
  token
) => {
  if (
    !token ||
    typeof token !== "string"
  ) {
    return false;
  }

  if (
    token.length < 32 ||
    token.length > 128
  ) {
    return false;
  }

  return /^[a-f0-9]+$/i.test(token);
};


/*
|--------------------------------------------------------------------------
| GET PUBLIC OFFER TOKEN
|--------------------------------------------------------------------------
*/

export const getPublicOfferToken =
  (value) => {
    if (!value) {
      return null;
    }

    if (
      typeof value === "string"
    ) {
      return value;
    }

    return value?.token || null;
  };
